import { Grid } from "@mui/material";
import React from "react";
import "./create.css";

function CreateCard() {
  const createData = [
    {
      iconSrc: "./Assets/ShoppingBag.png",
      createH: "Sell One Time",
      createP: "your collectible want to be one of a kind",
      btnT: "Create Single",
    },
    {
      iconSrc: "./Assets/ShoppingBag.png",
      createH: "Sell Multiple Time",
      createP: "your collectible want to be one of a kind",
      btnT: "Create Multiple",
    },
  ];
  return (
    <div>
      <Grid container justifyContent="center">
        <Grid item xs={11} md={10}>
          {/* NESTED GRID */}
          <Grid container justifyContent="center">
            {createData.map((e) => {
              return (
                <Grid item lg={5}>
                  <div className="create_card">
                    <img src={e.iconSrc} alt="" />
                    <h1 className="create_h">{e.createH}</h1>
                    <p className="create_h">{e.createP}</p>
                    <button className="common_btn">{e.btnT}</button>
                  </div>
                </Grid>
              );
            })}
          </Grid>
          {/* NESTED GRID */}
        </Grid>
      </Grid>
    </div>
  );
}

export default CreateCard;
